import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class DataHandlerGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var dataHandlerGrid = this;
		setTimeout(function(){
			dataHandlerGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var dataHandlerGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'visType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Visibility Type',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						combo.items = [
							{ 'code': '', 'description': 'All' },
							{ 'code': 'G', 'description': 'Global' },
							{ 'code': 'C', 'description': 'Company' },
							{ 'code': 'U', 'description': 'User' }
						];						
					},
					value: 'C',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'setVisibility',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['ADMIN_DATA_HANDLER_VISIBILITY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:eye', ' Set Visibility')
					],
					listeners: {
						click: function() {
							actionSetVisibility(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'manage',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_DATA_HANDLER_VISIBILITY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Manage')						
					],
					listeners: {
						click: function() {
							actionManage(grid.selectedItems[0]);
						}
					}					
				}								
			]
		});

		var grid;
		var getSelectedEffectiveType = function(record) {
			if (!record) {
				return null;
			}
			return record.effectiveVisibilityType || record.defaultVisibilityType || record.visibilityType;
		};

		var isCompanyEffective = function(record) {
			return getSelectedEffectiveType(record) === 'C';
		};

		var isUserEffective = function(record) {
			return getSelectedEffectiveType(record) === 'U';
		};

		var visibilityLabel = function(code) {
			if (code === 'G') {
				return 'Global';
			}
			if (code === 'C') {
				return 'Company';
			}
			if (code === 'U') {
				return 'User';
			}
			return code || '';
		};

		var updateActionButtons = function() {
			if (!grid) {
				return;
			}
			var selected = grid.selectedItems.length > 0 ? grid.selectedItems[0] : null;
			ElementUtil.query(toolbar, 'setVisibility').disabled = !selected;
			var manageButton = ElementUtil.query(toolbar, 'manage');
			if (!selected) {
				manageButton.disabled = true;
				manageButton.innerHTML = '';
				manageButton.appendChild(ElementUtil.makeIcon('vaadin:cog', ' Manage'));
				return;
			}
			if (isCompanyEffective(selected)) {
				manageButton.disabled = false;
				manageButton.innerHTML = '';
				manageButton.appendChild(ElementUtil.makeIcon('vaadin:cog', ' Manage Companies'));
			} else if (isUserEffective(selected)) {
				manageButton.disabled = false;
				manageButton.innerHTML = '';
				manageButton.appendChild(ElementUtil.makeIcon('vaadin:cog', ' Manage Users'));
			} else {
				manageButton.disabled = true;
				manageButton.innerHTML = '';
				manageButton.appendChild(ElementUtil.makeIcon('vaadin:cog', ' Manage'));
			}
		};
			
		grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'handlerId',
					header: 'Handler Id',
					width: '7em'
				},
				{						
					path: 'description',
					header: 'Description',
					width: '7em'
				},	
				{						
					path: 'dataType',
					header: 'Data Type',					
					width: '7em'
				},
				{						
					path: 'module',
					header: 'Module',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'defaultVisibilityDisplay',					
					header: 'Default Visibility',
					'text-align': 'center',
					width: '7em'
				},
				{
					path: 'effectiveVisibilityDisplay',
					header: 'Effective Visibility',
					'text-align': 'center',
					width: '9em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					updateActionButtons();
				}
			}
		});	
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'format-visibility',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'format-visibility.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		dataHandlerGrid.append(flexLayout);		
			
		var actionRefresh = function() {	
			var loadMask = grid.showLoading();
			var visibilityType = ElementUtil.query(toolbar, 'visType').value;
			DataManagementService.getDataHandlerService().getDataHandlers(visibilityType).then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				(data || []).forEach(function(item) {
					var defaultType = item.defaultVisibilityType || item.visibilityType || '';
					var effective = item.effectiveVisibilityType || defaultType;
					item.defaultVisibilityDisplay = visibilityLabel(defaultType);
					item.effectiveVisibilityDisplay = item.hasOverride
						? visibilityLabel(effective) + ' (override)'
						: visibilityLabel(effective);
				});
				grid.items = data;
				updateActionButtons();
			});			
		};
		setTimeout(function(){
			actionRefresh();
		}, 500);

		var actionSetVisibility = function(record) {
			var setWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Set Visibility - ' + record.description,
				icon: 'vaadin:eye',
				width: 520,
				height: 220,
				listeners: {
					ready: function() {
						setWin.show();

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-combo-box',
											style: 'width: 400px;',
											label: 'Visibility Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											name: 'visibilityType',
											postinit: function(combo) {
												combo.items = [
													{ code: 'G', description: 'Global' },
													{ code: 'C', description: 'Company' },
													{ code: 'U', description: 'User' }
												];
												combo.value = getSelectedEffectiveType(record) || '';
											}
										},
										{
											tag: 'div',
											colspan: 2,
											style: 'color: #666; font-size: 0.9em;',
											innerHTML: 'Default: ' + visibilityLabel(record.defaultVisibilityType || record.visibilityType || '') +
												(record.hasOverride ? ' (currently overridden)' : '')
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save Override')
													],
													listeners: {
														click: function() {
															var data = formPanel.getData();
															DataManagementService.getDataHandlerService()
																.saveVisibilityOverride(record.handlerId, data.visibilityType)
																.then(function() {
																	window.DL.MessageUtil.showToast('Success', 'Visibility override saved', {
																		theme: 'success'
																	});
																	actionRefresh();
																	setWin.close();
																});
														}
													}
												},
												{
													theme: 'error tertiary',
													innerHTML: 'Clear Override',
													style: 'margin-left: 10px;',
													properties: {
														disabled: !record.hasOverride
													},
													listeners: {
														click: function() {
															DataManagementService.getDataHandlerService()
																.clearVisibilityOverride(record.handlerId)
																.then(function() {
																	window.DL.MessageUtil.showToast('Success', 'Visibility override cleared', {
																		theme: 'success'
																	});
																	actionRefresh();
																	setWin.close();
																});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															setWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});

						setWin.addToContentElement(formPanel);
					}
				}
			});
		};
				
		var actionManage = function(record) {
			var companyHandler = isCompanyEffective(record);
			
			var manageWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage ' + record.description,
				icon: 'vaadin:cog',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						manageWin.show();
						
						var manageToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									'class': 'spacer-toolbar-item',									
									permissions: ['ADMIN_DATA_HANDLER_VISIBILITY:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											actionAdd();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'delete',
									theme: 'error primary',					
									permissions: ['ADMIN_DATA_HANDLER_VISIBILITY:DELETE'],
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									disabled: true,
									children:[
										ElementUtil.makeIcon('vaadin:trash', ' Delete')
									],
									listeners: {
										click: function() {
											actionDelete(manageGrid.selectedItems[0]);
										}
									}
								}				
							]
						});		

						var manageGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [								
								{						
									path: 'itemName',
									header: (companyHandler ? 'Company' : 'Username'),
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									manageGrid.selectedItems = item ? [item] : [];

									if (manageGrid.selectedItems.length > 0) {					  
										ElementUtil.query(manageToolbar, 'delete').disabled = false; 									
									} else {						
										ElementUtil.query(manageToolbar, 'delete').disabled = true;
									}
								}
							}
						});							
						
						var managelayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								manageToolbar,
								manageGrid
							]
						});	
						
						manageWin.addToContentElement(managelayout);
						
						var loadedItems = [];
						var actionRefreshManageGrid = function() {
							var loadMask = manageGrid.showLoading();	
							
							if (companyHandler) {
								DataManagementService.getDataHandlerService().getDataHandlerCompanies(record.handlerId).then(function(data){
									loadMask.remove();

									var items = [];
									data.forEach(function(item){
										items.push({
											itemId: item.companyId,											
											itemName: item.companyName
										});
									});

									manageGrid.activeItem = null;
									loadedItems = items.slice(0);
									manageGrid.items = items;				
								});	
							} else {
								DataManagementService.getDataHandlerService().getDataHandlerUsers(record.handlerId).then(function(data){
									loadMask.remove();

									var items = [];
									data.forEach(function(item){
										items.push({
											itemId: item.username,
											itemName: item.username
										});
									});

									manageGrid.activeItem = null;
									loadedItems = items.slice(0);
									manageGrid.items = items;					
								});
							}							
						};
						actionRefreshManageGrid();
						
						var actionAdd = function() {
							
							var addWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add ' + (companyHandler ? 'Company' : 'User'),
								icon: 'vaadin:plus',				
								width: 500,
								height: 170,
								listeners: {
									ready: function() {						
										addWin.show();	

										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [
														{
															tag: 'vaadin-combo-box',															
															style: 'width: 400px;',
															label: (companyHandler ? 'Company' : 'User'),
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															name: 'itemSelect',
															dataProvider: function(params, callback) {
																var index = params.page * params.pageSize;
																var loadParams = {
																	offset: index,
																	max: params.pageSize																	
																};
																
																if (companyHandler) {
																	loadParams.sortField = 'companyName';
																	loadParams.name = params.filter;
																	
																	Service.getCompanyService().loadCompanies(loadParams).then(function(results){
																		var lookups = [];
																		var existing = {};
																		loadedItems.forEach(function(i){
																			existing[i.itemId] = true;
																		});
																		
																		results.data.forEach(function(company){
																			if (!existing[company.companyId]) {
																				lookups.push({
																					code: company.companyId,
																					description: company.companyName
																				});
																			}
																		});
																		
																		callback(lookups, results.totalNumber);
																	});
																} else {
																	loadParams.sortField = 'firstname';
																	loadParams.filterField = 'firstname';
																	loadParams.filterValue = params.filter;
																	
																	Service.getUserService().getUsers(loadParams).then(function(results){
																		var lookups = [];
																		var existing = {};
																		loadedItems.forEach(function(i){
																			existing[i.itemId] = true;
																		});
																		
																		results.data.forEach(function(user){
																			var profile = user.userProfile || {};
																			var userId = profile.userId;
																			if (userId && !existing[userId]) {
																				lookups.push({
																					code: userId,
																					description: (profile.firstname || '') + ' ' + (profile.lastname || '') + ' (' + userId + ')'
																				});
																			}
																		});
																		
																		callback(lookups, results.totalNumber);
																	});
																}																
															} 															
														},																										
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {															
																			var data = formPanel.getData();
																			if (companyHandler) {
																				DataManagementService.getDataHandlerService().addCompanyToHandler({
																					dataHandlerId: record.handlerId,
																					companyId: data.itemSelect
																				}).then(function(){
																					actionRefreshManageGrid();
																					addWin.close();
																				});																				
																			} else {
																				DataManagementService.getDataHandlerService().addUserToHandler(record.handlerId, data.itemSelect).then(function(){
																					actionRefreshManageGrid();
																					addWin.close();
																				});
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			addWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										
										addWin.addToContentElement(formPanel);										
										
									}
								}
							});	
							
						};
						
						var actionDelete = function(item) {
						window.DL.MessageUtil.showConfirm({
							title: 'Confirm Delete',
							message: 'Are you sure you want to delete ' + item.itemName + '?',
							buttons: [
								{
									text: 'Yes',
									handler: function() {
										var loadMask = manageGrid.showLoading('Deleting...');
										
										if (companyHandler) {
											DataManagementService.getDataHandlerService().removeCompanyFromHandler(record.handlerId, item.itemId)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Deleted', {									
													theme: 'success'
												});
												actionRefreshManageGrid();
											});												
										} else {
											DataManagementService.getDataHandlerService().removeUserFromHandler(record.handlerId, item.itemId)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Deleted', {									
													theme: 'success'
												});
												actionRefreshManageGrid();
											});
										}
									}
								},
								{
									text: 'No'
								}
							]
						});							
						};
						
					}
				}
			});			
		};

	}
	
}
customElements.define('dl-datahandler-grid', DataHandlerGrid);
